import './sticky-sidebars';
import '../Libraries/Accordion'
import { findMany, find, on, removeClass, addClass } from '../Libraries/helpers';

let sidebar = find('[data-filters-sidebar]')

let deadzones = find('[data-scrim]');

const toggleSidebar = () => {
    const isOpen = sidebar.classList.contains('opened')

    if (isOpen) {
        removeClass(sidebar, 'opened')
        setTimeout(() => addClass(sidebar, 'hidden'), 400)
    } else {
        removeClass(sidebar, 'hidden');
        setTimeout(() => addClass(sidebar, 'opened'), 10)
    }
}

const handleScrim = mq => {
    const isOpen = sidebar.classList.contains('opened')

    if (!isOpen) {
        return false;
    }

    if (mq.matches) {
        addClass(deadzones, 'invisible');
        removeClass(deadzones, 'is-open');
    } else {
        addClass(deadzones, 'is-open');
        removeClass(deadzones, 'invisible');
    }
}

const listen = () => {
    findMany('[data-toggle-filters]').forEach(button => {
        on('click', toggleSidebar, button)
    })

    if (sidebar) {
        addClass(sidebar, 'can-transition')

        const mq = window.matchMedia('(min-width: 1025px')

        mq.addListener(handleScrim)
        handleScrim(mq)
    }

    return null;
}

listen()

window.filtersSidebar = function() {
    sidebar = find('[data-filters-sidebar]')
    deadzones = find('[data-scrim]');
    listen();
}
